import React, { useContext } from "react";

const LocationIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 20.1875C8.5 20.1875 17 14.875 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 14.875 8.5 20.1875 8.5 20.1875ZM8.5 11.6875C10.2604 11.6875 11.6875 10.2604 11.6875 8.5C11.6875 6.73959 10.2604 5.3125 8.5 5.3125C6.73959 5.3125 5.3125 6.73959 5.3125 8.5C5.3125 10.2604 6.73959 11.6875 8.5 11.6875Z"
        fill={color}
      />
    </svg>
  );
};
export default LocationIcon;
